import { render, staticRenderFns } from "./iconic.vue?vue&type=template&id=2a40b70a"
import script from "./iconic.vue?vue&type=script&lang=js"
export * from "./iconic.vue?vue&type=script&lang=js"
import style0 from "./iconic.vue?vue&type=style&index=0&id=2a40b70a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports